import * as React from 'react';

import {Button} from 'shells/button/button';
import {RemoveButton} from 'shells/button/remove-button/remove-button';
import {Card} from 'shells/card/card';
import {colors} from 'shells/colors/colors';
import {Label} from 'shells/form/label';
// @ts-expect-error - imported from .js/.jsx file
import {CheckmarkIcon} from 'shells/icon/svg/checkmark-icon';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {TextField} from 'shells/textfield/textfield';
import {Body} from 'shells/typography/body';

import styles from './coupon-field.module.css';

type Props = {
    couponCode: string | null | undefined;
    onChangeCouponCode: (value?: string | null | undefined) => void;
    userSuppliedCouponApplied: boolean;
    errorMessage: string | null | undefined;
    isApplyingCoupon: boolean;
};

export function CouponField(props: Props) {
    const [couponCode, setCouponCode] = React.useState(props.couponCode);
    const handleCouponChange = () => {
        if (couponCode === '') {
            // Don't try to apply an empty string as a coupon code
            props.onChangeCouponCode(null);
        }

        props.onChangeCouponCode(couponCode);
    };

    // If we're in the process of applying the coupon, we'll show the Applying… placeholder so can't show the value
    const valueToShow = props.isApplyingCoupon ? '' : couponCode || '';
    const placeholder = props.isApplyingCoupon ? 'Applying…' : undefined;

    return (
        <div className={styles['coupon-field']}>
            {props.userSuppliedCouponApplied && couponCode ? (
                <div className={styles['coupon-field']}>
                    <Card hasBorder={true} fitHeight={true} borderColor={colors.success}>
                        <div className={styles['coupon-applied']}>
                            <div className='flex justify-sb'>
                                <div className='flex align-center gap-16'>
                                    <CheckmarkIcon
                                        color={colors.success}
                                        size={20}
                                        alignCenter={true}
                                    />
                                    <Body isBold={true}>{couponCode}</Body>
                                </div>
                                <RemoveButton
                                    onClick={() => {
                                        setCouponCode(null);
                                        props.onChangeCouponCode(null);
                                    }}
                                    variant='dark'
                                />
                            </div>
                        </div>
                    </Card>
                </div>
            ) : (
                <StackLegacy spacing={8}>
                    <div className='flex justify-sb'>
                        <Label inline={true} htmlFor='numEnabledUsers'>
                            Enter coupon or promo code
                        </Label>
                        {couponCode && (
                            <div>
                                <Button
                                    variant='text-primary'
                                    noPadding={true}
                                    onClick={handleCouponChange}
                                >
                                    Apply
                                </Button>
                            </div>
                        )}
                    </div>
                    <TextField
                        id='coupon'
                        // @ts-expect-error
                        name='coupon'
                        hasError={Boolean(props.errorMessage)}
                        value={valueToShow}
                        placeholder={placeholder}
                        onChange={setCouponCode}
                        onEnter={handleCouponChange}
                        selectOnFocus={true}
                    />
                    {props.errorMessage && (
                        <Body size='small' color='error'>
                            {props.errorMessage}
                        </Body>
                    )}
                </StackLegacy>
            )}
        </div>
    );
}
